export default {"src":"/_next/static/image/public/images/ic_saved_card.c83816199ca7dae7ebb491e22c95b8af.svg","height":18,"width":26};